import GoogleChartContainer from "../../Componant/Charts/GoogleChart";

const GoogleChart = () => {
  return (
    <div className="page-body">
      <GoogleChartContainer />
    </div>
  );
};

export default GoogleChart;
